import * as React from "react";
import { forwardRef } from "react";
const SvgReportTraining = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 512, height: 512, x: 0, y: 0, viewBox: "0 0 682.667 682.667", style: {
  enableBackground: "new 0 0 512 512"
}, xmlSpace: "preserve", className: "", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "b", clipPathUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("path", { d: "M0 512h512V0H0Z", fill: "#ffffff", opacity: 1, "data-original": "#000000", className: "" }))), /* @__PURE__ */ React.createElement("mask", { id: "a" }, /* @__PURE__ */ React.createElement("rect", { width: "100%", height: "100%", fill: "#ffffff", opacity: 1, "data-original": "#ffffff", className: "" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c5.52 0 10-4.48 10-10S5.52-20 0-20s-10 4.48-10 10S-5.52 0 0 0", style: {
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none"
}, transform: "matrix(1.33333 0 0 -1.33333 333.333 213.333)", fill: "#ffffff", "data-original": "#ffffff", className: "" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c5.52 0 10-4.48 10-10S5.52-20 0-20s-10 4.48-10 10S-5.52 0 0 0", style: {
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none"
}, transform: "matrix(1.33333 0 0 -1.33333 333.333 266.667)", fill: "#ffffff", "data-original": "#ffffff", className: "" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#a)" }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#b)", transform: "matrix(1.33333 0 0 -1.33333 0 682.667)" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0c5.52 0 10-4.48 10-10S5.52-20 0-20s-10 4.48-10 10S-5.52 0 0 0", style: {
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none"
}, transform: "translate(250 352)", fill: "#ffffff", "data-original": "#000000", className: "", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c5.52 0 10-4.48 10-10S5.52-20 0-20s-10 4.48-10 10S-5.52 0 0 0", style: {
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none"
}, transform: "translate(250 312)", fill: "#ffffff", "data-original": "#000000", className: "", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h-100v100", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(502 402)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h106", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(256 442)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h106", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(256 402)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c0-48.38-34.36-88.74-80-98-6.46-1.31-13.15-2-20-2-55.23 0-100 44.77-100 100s44.77 100 100 100c6.85 0 13.54-.69 20-2C-34.36 88.74 0 48.38 0 0Z", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(210 342)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c-33.09 0-60 26.91-60 60", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(110 282)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v-100h100", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(110 442)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v-214c0-11.05 8.95-20 20-20h332c11.05 0 20 8.95 20 20v372L272 258H20c-11.05 0-20-8.95-20-20v-42", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(130 244)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c0-11.05-8.95-20-20-20s-20 8.95-20 20 8.95 20 20 20c5.52 0 10.52-2.24 14.14-5.86C-2.24 10.52 0 5.52 0 0Z", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(210 96)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0a19.938 19.938 0 0 0-5.86 14.14c0 11.05 8.95 20 20 20s20-8.95 20-20c0-5.52-2.24-10.52-5.86-14.14a19.938 19.938 0 0 0-14.14-5.86C8.62-5.86 3.62-3.62 0 0Z", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(251.86 161.86)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c0-11.05-8.95-20-20-20s-20 8.95-20 20c0 5.52 2.24 10.52 5.86 14.14C-30.52 17.76-25.52 20-20 20-8.95 20 0 11.05 0 0Z", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(356 96)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c0-11.05-8.95-20-20-20s-20 8.95-20 20 8.95 20 20 20S0 11.05 0 0Z", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(459 216)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "m0 0 47.72 51.72", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(204.14 110.14)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "m0 0 41.72-51.72", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(280.14 161.86)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "m0 0 80.8 86.72", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(347.1 112.64)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h152", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(290 342)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h152", style: {
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(290 302)", fill: "none", stroke: "#ffffff", strokeWidth: 20, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 })))));
const ForwardRef = forwardRef(SvgReportTraining);
export default ForwardRef;
